<template>
  <div>
    <!-- 最后一个增加and -->
    <template v-if="!!$slots.explain">
      <slot name="explain" />
    </template>
    <template v-else>
      {{ $t('common.countryblock_tit__before') }}
    </template>
    <br />
    <span v-for="(country, index) in countryList" :key="country.code" style="color: #91a5b1">
      {{ index === countryList.length - 1 && countryList.length > 1 ? $t('kyc.and') : ''
      }}{{ country[locale] || country.desc }}{{ getSymbol(index === countryList.length - 1) }}
    </span>
    <br />
    <br />
    {{ $t('common.countryblock_tit__after') }}
  </div>
</template>
<script>
export default {
  name: 'KycLimitCountry',
  props: {
    countryList: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    locale() {
      return this.store?.locale
    },
  },
  methods: {
    getSymbol(isLast) {
      if (isLast) {
        return this.locale === 'cn' ? '。' : '.'
      } else {
        return this.locale === 'cn' ? '，' : ','
      }
    },
  },
}
</script>
<script setup>
import { useI18n } from "vue-i18n";
const { t } = useI18n();
</script>
